import { useTranslation } from 'react-i18next';

export default function CtaSection() {
  const { t } = useTranslation('home');

  return (
    <section className="relative flex flex-col lg:flex-row min-h-[500px]">
      {/* Left side - Image */}
      <div className="lg:w-1/2 relative min-h-[350px] lg:min-h-[500px]">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20fashion%20shopping%20concept%20with%20smartphone%20displaying%20product%20catalog%20next%20to%20stylish%20accessories%20on%20light%20wood%20desk%2C%20warm%20natural%20morning%20light%20from%20large%20window%2C%20cozy%20lifestyle%20photography%2C%20contemporary%20consumer%20aesthetic%2C%20clean%20minimal%20composition%2C%20aspirational%20mood&width=900&height=600&seq=cta-v2-image&orientation=landscape"
          alt="CSSBuy Spreadsheet Products"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute top-6 left-6">
          <span className="inline-block px-4 py-1.5 bg-background-50/90 text-foreground-800 rounded-full text-xs font-medium">
            {t('cta.tag')}
          </span>
        </div>
        <div className="absolute bottom-6 left-6">
          <p className="text-3xl md:text-4xl lg:text-5xl font-heading font-extrabold text-background-50 leading-tight drop-shadow-lg">
            {t('cta.title1')}
            <br />
            {t('cta.title2')}
            <br />
            {t('cta.title3')}
          </p>
        </div>
      </div>

      {/* Right side - CTA */}
      <div className="lg:w-1/2 flex flex-col items-center justify-center px-6 md:px-12 py-12 lg:py-0 bg-background-50">
        <div className="max-w-md w-full text-center">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-extrabold text-foreground-950 mb-4 leading-tight">
            {t('cta.heading1')}
            <br />
            {t('cta.heading2')}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
            {t('cta.description')}
          </p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-4 bg-accent-500 text-background-50 rounded-full text-base font-semibold hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            {t('cta.button')}
            <i className="ri-arrow-right-up-line w-5 h-5 flex items-center justify-center" />
          </a>
        </div>
      </div>
    </section>
  );
}